import { isDisplayableSustainabilityTier, sustainabilityBadgeIcon } from '@/config/sustainability';

export function useSustainability() {
  const getSustainabilityLevel = function (categories) {
    if (!categories?.length) {
      return null;
    }

    const sustainabilityInfo = categories[categories.length - 1];
    if (!isDisplayableSustainabilityTier(sustainabilityInfo?.category_id)) {
      return null;
    }

    const sustainabilityTier = sustainabilityInfo.category_id.replace('SUSTAINABILITY_TIER_', '');
    return {
      tier: sustainabilityTier,
      icon: sustainabilityBadgeIcon,
      description: sustainabilityInfo?.category_description,
    };
  };

  return { getSustainabilityLevel };
}
